import React from 'react';

import { Layout, Breadcrumb, Modal } from 'antd/lib';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import { verPdf } from '../../common/funciones/verPdf';

import generarPlanillaEstadistica from '../../../graphql/mutations/estadistica/generarPlanillaEstadistica.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import FormSelectFechaYOrg from './FormSelectFechaYOrg';
import { errorService } from '../../../graphql/utils/utils';

@graphql(getUsuario)
class GenerarPlanilla extends React.Component {
  state = {
    depositos: [],
    fechaInicio: '',
    fechaFin: '',
    step: 0,
  };

  onSubmit = e => {
    e.preventDefault();
    // console.log(e);
    this.buscar();
  };

  // eslint-disable-next-line no-unused-vars
  buscar = (anio, idOrganismo, nombreOrganismo) => {
    this.setState({
      loading: true,
    });
    this.props.client
      .mutate({
        mutation: generarPlanillaEstadistica,
        variables: { anio, idOrganismo },
      })
      .then(res => {
        let planillaEstadistica = res.data.generarPlanillaEstadistica;

        // console.log('La planilla queda');
        // console.log(planillaEstadistica);

        if (planillaEstadistica && planillaEstadistica.planilla64) {
          // console.log('ENTRE A VER EL PDF');
          verPdf(
            planillaEstadistica.planilla64,
            `Planilla_ESTADISTICA_${idOrganismo}_${anio}`
          );
        }

        this.setState({
          loading: false,
        });
      })
      .catch(error => {
        console.log('Error en la obtencion de la planilla de estadistica');
        console.log(error);

        Modal.error({
          title: 'Error en la obtencion de la planilla de estadistica',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });

        errorService(error, {
          datosParaPlanilla: {
            anio,
            idOrganismo,
          },
        });
        this.setState({
          loading: false,
        });
      });
  };

  onCancelar = () => {
    this.setState({
      ...this.state,
      step: 0,
    });
  };

  render() {
    const { data } = this.props;
    if (data.loading || this.state.loading) {
      return <Loading />;
    }

    if (!data.getUsuario) {
      return null;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Estadistica</Breadcrumb.Item>
          <Breadcrumb.Item>Reportes</Breadcrumb.Item>
          <Breadcrumb.Item>Planilla Estadistica</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h1 className="tituloForm">Subdireccion de Planificacion</h1>
          <FormSelectFechaYOrg buscar={this.buscar} buscarSQL={false} />
        </Layout>
      </div>
    );
  }
}

export default withApollo(GenerarPlanilla);
